export default __webpack_public_path__ + "static/media/kaia-kaia-logo.c7fbbf1a.png";